export default __webpack_public_path__ + "static/media/Boots of the Huntmaster.5e24be85.jpg";